import { BrowserRouter } from "react-router-dom";
import { hydrateRoot } from "react-dom/client";
import { App } from "./app";
import { Store } from "../shared/types";

declare var _STORE: Store;

hydrateRoot(
  document.getElementById("sso")!,
  <BrowserRouter>
    <App store={_STORE} />
  </BrowserRouter>,
);
